<template>
  <form
    @submit.prevent="$emit('next')"
    class="payment-options col mt-9 mt-lg-0"
  >
    <action-dispatcher
      v-if="!form.billet_installments || form.billet_installments == 1"
      action="product/getPaymentMethods"
    >
      <div class="mt-6">Opções de pagamento disponíveis</div>
      <div class="pl-5">
        <b-form-checkbox-group
          class="mt-5 form-group"
          id="payment"
          v-model="form.payment_methods_ids"
        >
          <div
            v-for="(method, i) in _paymentMethods"
            :key="i"
            class="d-flex align-items-center pt-2"
          >
            <b-form-checkbox :value="method.id">
              {{ method.name }}
            </b-form-checkbox>
            <bp-tooltip
              v-if="
                (['two_credit_card'].includes(method.code) ||
                  ['card_pix'].includes(method.code)) &&
                  form.type_product == 'signature'
              "
              text="Esse tipo de pagamento não gerará assinatura do produto."
            >
              <bp-icon
                size="12"
                class="text-negative-500"
                icon="fa fa-circle-exclamation"
              />
            </bp-tooltip>
            <bp-tooltip
              v-if="
                ['pix'].includes(method.code) &&
                  form.type_product == 'onsite_event'
              "
              text="Os pedidos dessa forma de pagamento receberão o status de ‘pendente’ e haverá reserva do estoque por um prazo de 24h."
            >
              <bp-icon
                size="12"
                class="text-negative-500"
                icon="fa fa-circle-exclamation"
              />
            </bp-tooltip>
            <bp-tooltip
              v-if="
                ['billet'].includes(method.code) &&
                  form.type_product == 'onsite_event'
              "
              text="Os pedidos dessa forma de pagamento receberão o status de ‘pendente’ e haverá reserva do estoque seguindo o prazo configurado para vencimento do boleto."
            >
              <bp-icon
                size="12"
                class="text-negative-500"
                icon="fa fa-circle-exclamation"
              />
            </bp-tooltip>
          </div>
        </b-form-checkbox-group>
      </div>
    </action-dispatcher>

    <form-group
      class="mt-6"
      v-model="form.order_installment"
      id="order_installment"
      label="Ordenação do parcelamento"
      placeholder="Selecionar..."
      select
      :options="[
        { id: 'asc', name: 'Do menor para o maior' },
        { id: 'desc', name: 'Do maior para o menor' }
      ]"
      :errors="errors.order_installment"
    />

    <div class="d-flex align-items-center mt-6">
      <b-form-checkbox
        switch
        class="mr-5 text-switch"
        id="product-status"
        v-model="form.is_tax_to_producer"
      >
        Taxas para o produtor
      </b-form-checkbox>
    </div>
    <span class="small-text text-secondary">
      Em uma compra parcelada, o produtor pagará as taxas do parcelamento
    </span>

    <form-group
      class="mt-6"
      v-model="form.expire_billet"
      id="expire_billet"
      label="Prazo para vencimento do boleto"
      placeholder="Selecionar..."
      select
      :options="expireBilletOptions"
      :errors="errors.expire_billet"
    />
    <span class="small-text text-secondary">
      Este prazo não se aplica ao Multibanco. Neste caso, o prazo padrão será de
      3 dias corridos.
    </span>

    <hr class="my-6" />

    <div>Dias permitidos para gerar boleto no checkout</div>
    <small class="text-secondary">
      *Boletos emitidos aos sábados e domingos tem uma conversão 26% menor.
    </small>
    <div class="pl-5 pt-5">
      <form-group
        v-model="form.allow_week_billet.week"
        id="allow_week_billet"
        checkboxes
        :options="weekDays"
        :errors="errors.allow_week_billet"
      />
    </div>

    <!-- <hr />
    <h6 class="mt-9">Notificações de pagamentos</h6>

    <small class="text-secondary"
      >Configure as mensagens que mostrarão aos compradores que outras pessoas
      estão interessadas no produto.</small
    >

    <purple-button
      :title="'Adicionar notificação'"
      :description="'Clique para adicionar uma notificação.'"
      :icon="'icon-notification'"
      @action="$emit('create')"
    />

    <box-edit
      v-for="(notification, index) in form.show_notifications"
      :key="index"
      :title="notificationName(notification)"
      :description="`Mostrar a partir de ${notification.greater}`"
      @edit="$emit('edit', index)"
    /> -->

    <div class="d-sm-flex d-none justify-content-between mt-9">
      <button
        type="button"
        class="btn btn-outline-secondary d-flex align-items-center"
        @click="$emit('cancel')"
      >
        <i class="icon-angle-left mr-3" />
        Voltar
      </button>
      <div class="mx-3"></div>
      <button
        type="submit"
        class="btn d-flex align-items-center"
        :class="isValid ? 'btn-primary ' : 'btn-secondary'"
        :disabled="!isValid"
      >
        Próximo
        <i class="icon-angle-right ml-3" />
      </button>
    </div>
    <div class="d-sm-none justify-content-between mt-9">
      <button
        type="submit"
        class="btn btn-block align-items-center"
        :class="isValid ? 'btn-primary ' : 'btn-secondary'"
        :disabled="!isValid"
      >
        Próximo
        <i class="icon-angle-right ml-3" />
      </button>
      <div class="m-3" />
      <button
        type="button"
        class="btn btn-block btn-outline-secondary d-flex align-items-center"
        @click="$emit('cancel')"
      >
        <i class="icon-angle-left mr-3" />
        Voltar
      </button>
    </div>
  </form>
</template>

<script>
// import PurpleButton from "@/components/PurpleButton";
// import BoxEdit from "@/components/BoxEdit";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  components: {
    // PurpleButton,
    // BoxEdit
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    notificationTypes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      weekDays: [
        { id: 0, name: "Domingo" },
        { id: 1, name: "Segunda-feira" },
        { id: 2, name: "Terça-feira" },
        { id: 3, name: "Quarta-feira" },
        { id: 4, name: "Quinta-feira" },
        { id: 5, name: "Sexta-feira" },
        { id: 6, name: "Sábado" }
      ],
      expireBilletOptions: [
        { id: 1, name: "1 dia útil" },
        { id: 2, name: "2 dias úteis" },
        { id: 3, name: "3 dias úteis" },
        { id: 4, name: "4 dias úteis" },
        { id: 5, name: "5 dias úteis" }
      ]
    };
  },
  computed: {
    ...mapState("product", ["paymentMethods"]),
    _paymentMethods() {
      const order = [1, 4, 2, 3, 34];

      const orderedPaymentMethods = [...this.paymentMethods].sort(
        (a, b) => order.indexOf(a.id) - order.indexOf(b.id)
      );

      return orderedPaymentMethods;
    },
    isValid() {
      return this.form.expire_billet;
    }
  },
  methods: {
    notificationName(notification) {
      return get(
        this.notificationTypes.find(nt => nt.id === notification.type),
        "name"
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.payment-options {
  .icon-exclamation-solid {
    z-index: 2;
  }
  .tooltiptext {
    visibility: hidden;
    font-size: 10px;
    border-radius: 4px;
    z-index: 1;
    padding: 2px 8px;
    position: absolute;
    box-shadow: 0px 0px 4px rgba(33, 38, 49, 0.2);
    background-color: white;
    color: rgba(59, 59, 74, 0.9);
  }

  .text-switch {
    font-size: 14px;
  }

  .icon-angle-right,
  .icon-angle-left {
    font-size: 24px;
    margin-bottom: 3px;
  }
}
</style>
